import { resolveGenericStatusCardIcon } from '@/features/shared/components/chartPanels/StackedMetricsStatusChartSection.icons';
import { s } from '@/theme/tokens';
import { ReleasesIcon } from '@/ui/primitives';
import type { SxProps, Theme } from '@/ui/primitives';

export const resolveReleasesStatusCardIcon = (statusId: string): typeof ReleasesIcon => {
  if (statusId === 'total') return ReleasesIcon;
  return resolveGenericStatusCardIcon(statusId);
};

export const releaseModeTabsSx: SxProps<Theme> = {
  minHeight: '34px !important',
  '& .MuiTabs-flexContainer': { gap: s('sm') },
  '& .MuiTabs-indicator': {
    backgroundColor: 'text.primary',
    height: '1px',
  },
  '& .MuiTab-root': {
    fontSize: '1rem',
    fontWeight: 500,
    minHeight: '36px !important',
    height: '36px !important',
  },
};

export const releaseModeTabSx: SxProps<Theme> = {
  minHeight: '36px !important',
  height: '36px !important',
  px: s('md'),
  paddingTop: 0,
  paddingBottom: '8px',
  color: 'text.primary',
  fontWeight: 500,
  '&.Mui-selected': {
    color: 'text.primary',
    fontWeight: 500,
  },
};
